module.exports = "<div id=\"myModal\" class=\"modal\" #modal (click)=\"hide()\">\n    <div class=\"modal-content\">\n        <!-- single slot transclusion here -->\n        <ng-content></ng-content>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/modal/modal.component.html
// module id = ../../../../../src/app/shared/modal/modal.component.html
// module chunks = main